// extracted by mini-css-extract-plugin
export default {"expressCheckoutSection":"cw-z","expressButtonContainerWithPayPal":"dw-z","expressButton":"ew-z","or":"fw-z"};